import { Sparkles, Car, Smartphone, Plane, HeartPulse, BriefcaseBusiness, Utensils, ShoppingBag, Store } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const CATEGORY_ICON_MAP: Record<string, LucideIcon> = {
  "Beauty & Barber": Sparkles,
  "Cars & Rentals": Car,
  "Electronics": Smartphone,
  "Hotels & Travel": Plane,
  "Medical & Wellness": HeartPulse,
  "Professional Services": BriefcaseBusiness,
  "Restaurants & Cafés": Utensils,
  "Shopping & Lifestyle": ShoppingBag,
};

export function getCategoryIcon(name: string): LucideIcon {
  return CATEGORY_ICON_MAP[name] ?? Store;
}
